/* ==========================================================================
   OTOZIP JAKARTA SELATAN LANDING PAGE - ISOLATED JS
   Scope: .oz-jakarta-selatan-page
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.oz-jakarta-selatan-page');
  if (!root) return;

  // 1. FAQ Accordion Logic (Single Open)
  var faqTriggers = root.querySelectorAll('.oz-jakarta-selatan-faq-trigger');
  faqTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var isExpanded = this.getAttribute('aria-expanded') === 'true';
      var targetId = this.getAttribute('aria-controls');
      var targetAns = root.querySelector('#' + targetId);

      faqTriggers.forEach(function (otherTrigger) {
        if (otherTrigger !== trigger) {
          otherTrigger.setAttribute('aria-expanded', 'false');
          var otherId = otherTrigger.getAttribute('aria-controls');
          var otherAns = root.querySelector('#' + otherId);
          if (otherAns) {
            otherAns.hidden = true;
          }
        }
      });

      if (isExpanded) {
        this.setAttribute('aria-expanded', 'false');
        if (targetAns) targetAns.hidden = true;
      } else {
        this.setAttribute('aria-expanded', 'true');
        if (targetAns) targetAns.hidden = false;
      }
    });
  });

  // 2. SEO Text Collapsible Panel Toggle
  var seoToggleBtn = root.querySelector('#oz-jakarta-selatan-seo-toggle-btn');
  var seoContent = root.querySelector('#oz-jakarta-selatan-seo-content');

  if (seoToggleBtn && seoContent) {
    seoToggleBtn.addEventListener('click', function () {
      var isCollapsed = seoContent.classList.contains('collapsed');
      if (isCollapsed) {
        seoContent.classList.remove('collapsed');
        seoToggleBtn.innerHTML = 'Sembunyikan <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="18 15 12 9 6 15"/></svg>';
      } else {
        seoContent.classList.add('collapsed');
        seoToggleBtn.innerHTML = 'Lihat Selengkapnya <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>';
      }
    });
  }

  // 3. Area Chips Collapsible Toggle
  var areaToggleBtn = root.querySelector('#oz-jakarta-selatan-area-toggle-btn');
  var areaExtraChips = root.querySelectorAll('.oz-jakarta-selatan-chip-extra');

  if (areaToggleBtn && areaExtraChips.length > 0) {
    areaToggleBtn.addEventListener('click', function () {
      var isHidden = areaExtraChips[0].style.display === 'none';
      if (isHidden) {
        areaExtraChips.forEach(function (chip) {
          chip.style.display = 'flex';
        });
        areaToggleBtn.innerHTML = 'Sembunyikan <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="18 15 12 9 6 15"/></svg>';
      } else {
        areaExtraChips.forEach(function (chip) {
          chip.style.display = 'none';
        });
        areaToggleBtn.innerHTML = 'Tampilkan Semua Area <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>';
      }
    });
  }
});
